import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import data from "../assets/cctv.jpg";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div className="MainBodySection mb-5">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<h3 className="main-section-title">
									ICT & CCTV CAMERAS
								</h3>
							</div>

							<div className="col-md-12 bg-surface rounded p-3">
								<h5 className="font-semi-bold text-dim py-3">We provide end-to-end ICT and CCTV solutions for businesses, institutions, and government organizations, delivering reliable network infrastructure, security, and monitoring systems tailored to our clients’ needs.</h5>
								<img 
									style={{
										width:"100%",
										height:"auto"
									}}
									src={data} 
								/>
								<div>
									<h6 className="font-bold text-light bg-primary rounded p-2 my-3">
										Examples of ICT & CCTV Camera Projects:
									</h6>
									<h5
										style={{
											borderLeft:"5px solid var(--primaryColor)",
											padding: "10px"
										}}
									>
										• <b>Kenya Airport Authority (KAA)</b> - Installation, Maintenance, and Support of CCTV systems across JKIA, Mombasa International Airport, Kisumu Airport, Eldoret Airport & Wilson Airport. Integrated with secure network infrastructure and centralized monitoring.<br /><br/>
										• <b>Hilton Hotel (Kenya)</b> - Deployment of CCTV surveillance across all premises, including indoor and outdoor cameras, integrated with access control and real-time monitoring systems.<br /><br/>
										• <b>Continental Resort Mombasa</b> - Full CCTV installation including fiber backbone integration, wireless connectivity for remote monitoring, and preventive maintenance.<br /><br/>
										• <b>Safari Park Hotel Nairobi</b> - Comprehensive CCTV coverage, LAN integration, and continuous system support for enhanced security and operational monitoring.<br /><br/>
										• <b>Corporate Office Networks</b> - Structured cabling, network setup, firewall configuration, and integration of CCTV cameras for secure office environments.
									</h5>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}